/**
 * @tabler/icons-react v2.47.0 - MIT
 */

import createReactComponent from '../createReactComponent.js';

var IconChevronDownRight = createReactComponent(
  "chevron-down-right",
  "IconChevronDownRight",
  [["path", { d: "M16 8v8h-8", key: "svg-0" }]]
);

export { IconChevronDownRight as default };
//# sourceMappingURL=IconChevronDownRight.js.map
